<template>
  <div>
    <slot></slot>

    <div class="left-aligned">
      <div class="title">Creators:</div>
      <br>
      <img src="@/assets/img/person1.svg">
      <div class="creator-container">
        <a class="link page-link" href="https://dorathedeveloper.com">Dora Szucs</a>
        <div>Software engineer | M.Sc. Computer Science</div>
      </div>
      <br>
      <img src="@/assets/img/person2.svg">
      <div class="creator-container">
        <a class="link page-link" href="http://krisztinaszucs.com">Krisztina Szucs</a>
        <div>Data Visualization Designer | UX Designer</div>
      </div>
    </div>
    <br>
    <div class="left-aligned">
      Contact us at
      <a
        class="toc pseudo-button"
        href="mailto:contact@tinderinsights.com"
      >contact@tinderinsights.com</a>.
    </div>
    <br>
    <div class="left-aligned">
      <b>Tinder Insights</b> is an independent data visualization tool for online dating habits associated with the Tinder app. Tinder Insights is
      <b>not</b> part of Tinder or Match Group.
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",
  components: {},
  mounted() {
    this.$store.state.analytics.logEvent("contactpage visited");
  }
};
</script>

<style scoped>
img {
  width: 120px;
  height: auto;
  margin-right: 20px;
  margin-top: 10px;
}

img,
.creator-container {
  display: inline-block;
}

</style>
